// removed by extract-text-webpack-plugin
module.exports = {"spacing-small":"4px","spacing-medium":"8px","this":"UniversalComposerRecipientToken__this___1t7Tj","container":"UniversalComposerRecipientToken__container___Ror6o","avatar":"UniversalComposerRecipientToken__avatar___12O7e Spacing__marginRightMedium___bhiZC","name":"UniversalComposerRecipientToken__name___1LxQM"};


//////////////////
// WEBPACK FOOTER
// ./src/chat/components/styles/UniversalComposerRecipientToken.css
// module id = 1724
// module chunks = 4